import { ProjectAdministrationSubpage } from '../../../projectAdministrationLib';
import { SkuQuantityEntityListSpecification } from './SkuQuantityEntityListSpecification';

export class MinLayerEntityListSpecification extends SkuQuantityEntityListSpecification {
  constructor() {
    super(
      ProjectAdministrationSubpage.MINLAYERLISTS,
      'MinLayer list administration',
      'Min layer list',
      'Min layer lists',
      'ML',
      undefined,
      true, // Allow zero quantity for Min layer lists
    );
  }
}
